import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withXhr, withInterceptorsFromDi } from '@angular/common/http';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { StdModule, NtsAppRootModule } from '@nts/std';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
// import { AUTH_MOCK_MODE } from '@nts/std';
import { NtsBootService } from '@nts/std';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [BrowserModule,
AppRoutingModule,
BrowserAnimationsModule,
CommonModule,
FormsModule,
StdModule,
ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi()),

    {
      provide: EnvironmentConfiguration,
      useValue: { ...environment }
    },
    ...StdModule.getRootProviders(),
    // {
    //   provide: AUTH_MOCK_MODE,
    //   useValue: true
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends NtsAppRootModule {
  constructor(
    bootService: NtsBootService,
  ) {
    super(bootService);
  }
}
